import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-76c37d33"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "block-container" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FriedIcon = _resolveComponent("FriedIcon");
    const _component_FriedParagraph = _resolveComponent("FriedParagraph");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_FriedIcon, {
            class: "icon",
            icon: _ctx.icon
        }, null, 8, ["icon"]),
        _createVNode(_component_FriedParagraph, { class: "text" }, {
            default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.text), 1)
            ]),
            _: 1
        })
    ]));
}
